export default __webpack_public_path__ + "static/media/com-default-pic.0e37610f.svg";